import dayjs from 'dayjs';

import { useLocalization } from '../../../providers/LocaleProvider';
import { getDayJsLocale } from '../../../utils/dayjs-locale';

export const useMonthSelectOptions = () => {
  const { locale } = useLocalization();
  const dayJsLocale = getDayJsLocale(locale);
  const dateInstance = dayjs().locale(dayJsLocale);
  const months = new Array(12).fill(null).map((_, i) => ({
    value: (i + 1).toString(),
    label: dateInstance.month(i).format('MMMM'),
  }));

  return months;
};
